<!-- Lista de usuários no padrão da Gestão de Empréstimos (card 3697): cabeçalho, empresa, resumo em cards e a
     tabela com título, busca, filtros (funil) e colunas. -->
<section class="user-list" *appHasPermission="userPermissions.MODULE">
  <div class="user-list__breadcrumb">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
  </div>

  <div class="user-list__head">
    <div>
      <h1 class="user-list__title">{{ tk.User.Users | t }}</h1>
      <p class="user-list__subtitle">
        Gerencie quem acessa a plataforma, com qual perfil e em quais empresas.
      </p>
    </div>
    <ng-container *appHasPermission="userPermissions.CREATE">
      <app-button
        [id]="'add-group'"
        [label]="isMobile ? '' : 'Adicionar usuário'"
        [icon]="'pi pi-plus'"
        [type]="'button'"
        [fitContent]="true"
        [noMargin]="true"
        (sendButtonClick)="addUser()"></app-button>
    </ng-container>
  </div>

  <div class="user-list__company">
    <app-select-company
      [multiple]="true"
      [selectionScope]="'page-filter'"
      [persistLocalSelectionToUrl]="true"
      [selectedCompanyValues]="selectedCompanyIds"
      (sendSelectedOptionMultiple)="handleCompaniesChange($event)" />
  </div>

  <div class="user-list__summary">
    <p class="user-list__caption">Resumo dos usuários</p>
    <app-user-summary-cards
      [counts]="summaryCounts()"
      [selected]="selectedSummaryCard"
      (selectCard)="handleSummaryCard($event)" />
  </div>

  <app-user-filter
    [isVisible]="filterIsOpen"
    [current]="appliedFilters"
    (sendCloseFilter)="filterIsOpen = false"
    (sendFilter)="handleFilter($event)" />

  @if (activeFilterConfigs.length > 0) {
    <div class="user-list__chips">
      <app-active-filters
        [filterConfigs]="activeFilterConfigs"
        [showClearButton]="true"
        (filterRemoved)="onRemoveFilter($event)"
        (allFiltersCleared)="clearListFilters()" />
    </div>
  }

  <div class="user-list__content">
    <app-user-list-content
      [userList]="users"
      [pagination]="pagination"
      [loading]="loading"
      (sendSearch)="handleSearch($event)"
      (sendOpenFilter)="filterIsOpen = true"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"
      (sendTableSort)="handleTableSort($event)"></app-user-list-content>
  </div>
</section>
